const initialState = (entries, lastShownAt) => ({
  entries,
  entryIds: entries.map((e) => e.path.split("#")[1]),
  selected: null,
  collapsed: false,
  filters: {
    is_impactful: false,
    is_new_feature: false,
    label: null,
  },
  lastShownAt,
  limit: 10,
  offset: 0,
})

export default initialState
